import React from 'react';
import { SalesRepDashboardScreenDesktop } from './SalesRepDashboardScreenDesktop';
import { SalesRepDashboardScreenMobile } from './SalesRepDashboardScreenMobile';

export const SalesRepDashboardScreen = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SalesRepDashboardScreenMobile /> : <SalesRepDashboardScreenDesktop />;
};